import { apiConstatnts } from "constants/apiConstants";
import { store } from "store";
import { QueryParams } from "types/query";
import httpRequset from "utils/HttpRequest";
import queryString from "query-string";
import { compressImage } from "utils/compressImage";

const { REACT_APP_API_URL, REACT_APP_ACCESS_TOKEN } = process.env;

async function getPackages(queryParams: QueryParams) {
  try {
    const url = `${REACT_APP_API_URL}/package${queryParams ? `?${queryString.stringify(queryParams)}` : ""}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function createPackage(packageId: number) {
  try {
    const url = `${REACT_APP_API_URL}/package/record/create`;

    const body = JSON.stringify({
      user_id: store.getState()!.auth.user!["user_id"],
      package_id: packageId,
    });

    return httpRequset(apiConstatnts.POST, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, body);
  } catch (error) {
    throw error;
  }
}

async function getPackageRecords() {
  try {
    const userId = store.getState()?.auth?.user?.["user_id"];

    if (!userId) return;

    const params = {
      filter: `[user_id:eq:${userId}][status:eq:2]`,
    };

    const url = `${REACT_APP_API_URL}/package/record${params ? `?${queryString.stringify(params)}` : ""}`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.QUERY_STRING, url, null);
  } catch (error) {
    throw error;
  }
}

async function cancelPackageRecord(organization_package_user_record_id: number) {
  try {
    const userId = store.getState()?.auth?.user?.["user_id"];

    if (!userId) return;

    const params = JSON.stringify({
      status: false,
    });

    const url = `${REACT_APP_API_URL}/package/record/update/${organization_package_user_record_id}`;

    return httpRequset(apiConstatnts.PUT, apiConstatnts.ENABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, params);
  } catch (error) {
    throw error;
  }
}

async function uploadPackageRecordPaymentProof(package_record_id: number, image: File) {
  try {
    const url = `${REACT_APP_API_URL}/package/record/upload/payment-proof/${package_record_id}`;

    const myHeaders = new Headers();

    myHeaders.append("authorization", `Bearer ${REACT_APP_ACCESS_TOKEN}`);

    const compressedImage = await compressImage(image);

    const formData = new FormData();

    formData.append("package-record-payment-proof", compressedImage);

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions as any);

    const rawData = await response.text();

    const data = JSON.parse(rawData);

    return data.data;
  } catch (error) {
    throw error;
  }
}

export const packageService = {
  getPackages,
  createPackage,
  getPackageRecords,
  cancelPackageRecord,
  uploadPackageRecordPaymentProof,
};
